// project import
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Routes from './routes';
import ThemeCustomization from './themes';
import './firebase';
import { useIdle } from 'react-use';
import { useNavigate, useLocation } from 'react-router';
import { useDispatch } from 'react-redux';

// css
import './App.css';
import { useEffect } from 'react';

// ==============================|| APP - THEME, ROUTER, LOCAL  ||============================== //
const App = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const isIdle = useIdle(300000);

  console.log('Idle State: ', isIdle);

  useEffect(() => {
    if (isIdle && location.pathname !== '/') {
      dispatch({ type: 'RESET_USER_VERIFICATION' });
      navigate('/');
    }
  }, [isIdle]);

  return (
    <ThemeCustomization>
      <Routes />
      <ToastContainer position={'top-right'} autoClose={3000} />
    </ThemeCustomization>
  );
};

export default App;
